class RevieveVideoBubble extends HTMLElement {
  constructor() {
    super();

    if (window.location.pathname === '/challenge') return;

    this.classes = {
      expanded: 'is-expanded',
      hidden: 'is-hidden',
    };

    this.toggleButton = this.querySelector('[data-rvb-toggle]');
    this.closeButton = this.querySelector('[data-rvb-close]');
    this.revieveLink = this.querySelector('a[href="#revieve-popup"]');

    this.onToggleClick = this.onToggleClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onRevieveClick = this.onRevieveClick.bind(this);
  }

  connectedCallback() {
    this.toggleButton?.addEventListener('click', this.onToggleClick);
    this.closeButton?.addEventListener('click', this.onCloseClick);
    this.revieveLink?.addEventListener('click', this.onRevieveClick);

    if (Shopify.designMode) {
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }

  disconnectedCallback() {
    this.toggleButton?.removeEventListener('click', this.onToggleClick);
    this.closeButton?.removeEventListener('click', this.onCloseClick);
    this.revieveLink?.removeEventListener('click', this.onRevieveClick);

    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }

  onSectionSelect(event) {
    filterShopifyEvent(event, this, () => {
      this.classList.remove(this.classes.hidden);
      this.expand();
    });
  }

  onSectionDeselect(event) {
    filterShopifyEvent(event, this, () => {
      this.collapse();
    });
  }

  onToggleClick(event) {
    event.preventDefault();
    if (this.classList.contains(this.classes.expanded)) return;
    this.expand();
  }

  onCloseClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.dataset.dismissOnClose === 'true') {
      this.closeBubble();
      return;
    }

    this.collapse();
  }

  onRevieveClick() {
    this.closeBubble();
  }

  closeBubble() {
    this.collapse();
    this.classList.add(this.classes.hidden);
  }

  expand() {
    this.classList.add(this.classes.expanded);
    this.setAttribute('aria-expanded', 'true');
  }

  collapse() {
    this.classList.remove(this.classes.expanded);
    this.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('revieve-video-bubble', RevieveVideoBubble);

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('a[href="#revieve-popup"]');
  if (!trigger) return;

  document.querySelectorAll('revieve-video-bubble').forEach((bubble) => {
    bubble.closeBubble?.();
  });
});
